const state = () => ({
  dialogTitle: ''
});

const getters = {
  dialogTitle(state) {
    return state.dialogTitle;
  }
};

const mutations = {
  setDialogTitle(state, payload) {
    state.dialogTitle = payload;
  }
};

const actions = {
  setDialogTitle({ commit }, payload) {
    commit('setDialogTitle', payload);
  }
};

export const thematicCounselling = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
